import React from 'react';
import CurrencyFormat from 'react-currency-format';

const CurrencyValue = props => (
    <>
        {<CurrencyFormat value={parseFloat(props.value)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} decimalScale={2}/>} {props.currencyType}
    </>
)

export default CurrencyValue;